// Module
var code = "<div class=\"refresh-button\"> <button ng-click=\"onRefresh()\">Rafraîchir</button> </div>";
// Exports
module.exports = code;